import Stack from '@mui/material/Stack';
import { useMuiMediaQuery } from '../../../utilities/hooks';
import { CarTypeSelector } from '../../../components/CarTypeSelector';
import { IWhatKindOfCarsData } from './what-kind-of-cars-container';

interface IWhatKindOfCarsProps {
    data: IWhatKindOfCarsData;
    handleClick: (href: string, cardName: string) => (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

const useKindOfCarsLimit = () => {
    const { isTablet, isMobile } = useMuiMediaQuery();
    if (isMobile) return 3;
    if (isTablet) return 4;

    return 6;
};

const WhatKindOfCars = ({ data, handleClick }: IWhatKindOfCarsProps) => {
    const responsiveTileLimit = useKindOfCarsLimit();
    return (
        <Stack direction="row" spacing={1} sx={{ mt: { xs: 1.5, sm: 2 }, overflowX: 'hidden' }}>
            {data.vehicleTypes.slice(0, responsiveTileLimit).map((carType) => (
                <CarTypeSelector key={carType.displayName} carType={carType} handleClick={handleClick} />
            ))}
        </Stack>
    );
};

export default WhatKindOfCars;
